import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message, Radio, Modal  } from 'antd';
import { EyeFilled, EyeInvisibleFilled, ReloadOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import * as action from '../../store/actionCreators';
import { getUnifyLogin, getSafeCodeRequest, baseURL, getMsgCodeRequest, getMsgLoginRequest, getLoginRequest, getUserMobileLoginRequest, getUserLoginRequest, getBindMobileRequest } from '../../api/request';
import PlatformName from '../../components/PlatformName';
import './index.scss'
import RadioGroup from '../../components/RadioGroup';
import banner from '../../assets/images/banner.png';
import Icon from '../../components/Icon';
import MobileVerify from '../../components/MobileVerify';

const url = new URL(window.location.href);
const isOldVer = url.searchParams.get('v') === 'data';

/**
 * 登录页面
 * @param {*} props 
 * @returns 
 */

function Login(props) {
  const [loginInfo, setLoginInfo] = useState({name: '陕西干部教育统一登录认证'});
  const [value, setValue] = useState('');
  const [safeCode, setSafeCode] = useState('');
  const [msgCode, setMsgCode] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imgCodeValue, setImgCodeValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const defaultId = '196616394697080832';
  const [form] = Form.useForm();
  const reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
  const [countTime, setCountTime] = useState(60);
  let timer;
  const  [showCount, setShowCount]= useState(false)
  const [showMobileBind, setShowMobileBind] = useState(false);
  const [showMobileVerify, setShowMobileVerify] = useState(false);
  const [bindedPhoneNumber, setBindedPhoneNumber] = useState('');
  const [auth, setAuth] = useState({});

  // 登录通用处理函数
  const loginCommonHandler = (reqPromise) => {
    let addr = new URL(window.location.href);
    let app_id = addr.searchParams.get("app_id");
    let redirect_url = addr.searchParams.get("redirect_url");
    reqPromise
    .then((res) => {
      const {code, data = {}} = res;
      if(code === 'SUCCESS') {
        if(redirect_url) {
          const {authorization = {}} = data;
          message.success('登录成功');
          window.location.href =`${redirect_url}?app_id=${app_id}&access_token=${authorization.id}`
        } else {
          if(loginInfo.redirect_url) {
            const {authorization = {}} = data;
            message.success('登录成功');
            window.location.href =`${loginInfo.redirect_url}?app_id=${app_id ? app_id : defaultId}&access_token=${authorization.id}`
          }else {
            message.error('应用官网地址不存在！')
          }
        }
      } else {
        message.error(res.message)
        getSafeCode()
      }
    }).catch(err => {
      message.error(err)
    })
  }

  // 账号登录（需手机验证）- 手机绑定表单数据验证成功回调
  const handleMobileBindOk = (values) => {
    const payload = {
      ...values,
      auth: auth.id
    }
    getBindMobileRequest(payload)
    .then((res) => {
      const {code} = res;
      if(code === 'SUCCESS') {
        setShowMobileBind(false);
        message.success('绑定成功');
      } else {
        message.error(res.message)
      }
    }).catch(err => {
      message.error(err)
    })
  }

  // 处理取消手机绑定
  const handleMobileBindCancel = () => {
    getSafeCode();
    form.setFieldValue('captcha', '');
  }

  // 处理取消手机验证
  const handleMobileVerifyCancel = () => {
    getSafeCode();
    form.setFieldValue('captcha', '');
  }

  // 账号登录（需手机验证） - 手机验证表单数据验证成功回调
  const handleMobileVerifyOk = (values) => {
    let addr = new URL(window.location.href)
    let app_id = addr.searchParams.get("app_id")
    const appid = app_id ? app_id : defaultId;
    const payload = {
      ...values,
      app_id: appid,
      expires: loginInfo?.expires,  // 默认2小时过期 0为不过期 大于0为设置的时间
      auth: auth.id
    }
    const reqPromise = getUserMobileLoginRequest(payload);
    loginCommonHandler(reqPromise);
  }

  // 账号登录（需手机验证）
  const handleUserMobileLogin = (payload) => {
    getUserLoginRequest(payload) // 先执行账号登录请求，获取用户信息及验证信息
    .then((res) => {
      const {code, data = {}} = res;
      if(code === 'SUCCESS') {
        const mobile = data.user.mobile; // 获取用户手机号
        const auth = data.authorization; // 获取账户登录返回的验证信息
        setAuth(auth);
        if (mobile) { // 已绑定手机号
          setBindedPhoneNumber(mobile);
          setShowMobileVerify(true);
        } else { // 未绑定手机号，需先绑定手机号
          setShowMobileBind(true); 
        }
      } else {
        message.error(res.message)
        getSafeCode()
      }
    }).catch(err => {
      message.error(err)
    })
  }

  // 账号登录
  const onLogin = (values) => {
    const { username, password, captcha } = values
    let addr = new URL(window.location.href)
    let app_id = addr.searchParams.get("app_id")
    const appid = app_id ? app_id : defaultId
    const payload = {
      username,
      password: password,
      captcha,
      captcha_session_id: safeCode.id,
      expires: loginInfo?.expires,  // 默认2小时过期 0为不过期 大于0为设置的时间
      app_id: appid
    };

    // 账号登录（需手机验证）
    if (loginInfo.login_type?.find(type => type === 'USERNAME_MOBILE_LOGIN')) {
      handleUserMobileLogin(payload);
    // TODO:账号登录（需邮箱验证）
    } else if (loginInfo.login_type?.find(type => type === 'USERNAME_EMAIL_LOGIN')) {
     
    // 普通账号登录 
    } else {
      const reqPromise = getLoginRequest(payload);
      loginCommonHandler(reqPromise);
    }
  };

  // 手机登录
  const onMsgLogin = (values) => {
    const { phone_number, captcha } = values
    let addr = new URL(window.location.href)
    let app_id = addr.searchParams.get("app_id")
    let redirect_url = addr.searchParams.get("redirect_url")
    const appid = app_id ? app_id : defaultId
    const payload = {
      captcha,
      captcha_session_id: msgCode.id,
      expires: loginInfo?.expires,  // 默认2小时过期 0为不过期 大于0为设置的时间
      app_id: appid,
      phone_number
    };
    getMsgLoginRequest(
      {...payload}).
      then((res) => {
        const {code, data = {}} = res;
        if(code === 'SUCCESS') {
          if(redirect_url) {
            const {authorization = {}} = data;
            message.success('登录成功');
            window.location.href =`${redirect_url}?app_id=${app_id}&access_token=${authorization.id}`
            //window.location.href =`http://localhost:3002/?app_id=${app_id}&access_token=${res.data.authorization.id}`
          }else {
            const {authorization = {}} = data;
            if(loginInfo.redirect_url) {
              message.success('登录成功');
              window.location.href =`${loginInfo.redirect_url}?app_id=${app_id ? app_id : defaultId}&access_token=${authorization.id}`
            }else {
              message.error('应用官网地址不存在！')
            }
          }
        } else {
          message.error(res.message)
          getSafeCode()
        }
      }).catch(err => {
        message.error(err)
      })
    };

  useEffect(() => {
    // 统一登陆接口及跳转接口
    let addr = new URL(window.location.href)
    let app_id = addr.searchParams.get("app_id")
    const appid = app_id ? app_id : defaultId
    getUnifyLogin(appid).then((res) => {
      setLoginInfo(res.data)
    }).catch(err => {
      message.error(err)
    })
    getSafeCode()
  },[])


  //获取验证码
  const getSafeCode = () => {
    getSafeCodeRequest({}).then(res => {
      if(res.code === 'SUCCESS') {
        setSafeCode(res.data)
      }
    })
  }
  
  

  const onChange = e => {
    setValue(e.target.value);
    form.setFieldValue('captcha', '');
  };

  //发送短信验证码
  const sendMsgCode = async  () =>{

    if(!reg.test(phoneValue)) {
      message.error('请输入正确的手机号码');
      return;

    }
    const payload = {
      captcha:imgCodeValue,
      // "captcha_length": 0,
      "captcha_type": 0,
      "description": "",
      captcha_session_id: safeCode.id,
      expires: loginInfo?.expires,  // 默认2小时过期 0为不过期 大于0为设置的时间
      phone_number:phoneValue
    };

    getMsgCodeRequest(payload).then((res)=>{
      const {code,message:msg,data} = res
      if(code === 'SUCCESS'){
        message.success('发送成功');
        setIsModalOpen(false)
        setMsgCode(data)
        //开启倒计时
        setShowCount(true)
      
      }else{
        message.error(msg)
      }
      
    }).catch(err => {
      message.error(err)
    })

  }
    useEffect(() => {
    if (showCount ) {
      timer = setInterval(() => {
        if (countTime < 1) {
          setShowCount(false);
          clearInterval(timer);
          setCountTime(60);
          return;
        }
        setCountTime(countTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [showCount, countTime]);

  useEffect(() => {
    // 根据登录类型显示对应tab和表单
    if (!loginInfo?.login_type) {
      return;
    }
    if (loginInfo.login_type.find(type => type === 'USERNAME_LOGIN' || type === 'USERNAME_MOBILE_LOGIN' || type === 'USERNAME_EMAIL_LOGIN')) {
      setValue(1);
    } else if (loginInfo.login_type.find(type => type === 'MOBILE_LOGIN')) {
      setValue(2);
    }
  }, [loginInfo])

  return (
    <div className={`login-container ${isOldVer ? 'old' : ''}`}>

      <div className='main-cont'>
      
        <div className='platform-banner'>
        <h2><i></i><span><PlatformName loginInfo={loginInfo} /></span></h2>
          <img src={banner} alt=""/>
        </div>
        <div className='login-info-wrap'>
          
          <div className='login-info'>
            <div className='login-info-container'>
              <div className='switch-container'>
                <RadioGroup onChange={onChange} value={value}>
                {
                  loginInfo?.login_type?.find(type => type === 'USERNAME_LOGIN' || type === 'USERNAME_MOBILE_LOGIN' || type === 'USERNAME_EMAIL_LOGIN') ?
                  <Radio value={1}>帐号密码登录</Radio>
                  : null
                }
                {
                  loginInfo?.login_type?.find(type => type === 'MOBILE_LOGIN') ?
                  <Radio value={2}>手机快捷登录</Radio>
                  : null
                }
                </RadioGroup>
              </div>
              { // 账号登录
                value === 1 ?
                  <Form
                    name="normal_login"
                    className="login-form"
                    initialValues={{ remember: true }}
                    onFinish={onLogin}
                    form={form}
                  >
                    <Form.Item
                      name="username"
                      rules={[{ required: true, message: '请输入用户名！' }]}
                    >
                      <Input 
                        prefix={<Icon name="person2"/>} 
                        placeholder="请输入用户名" 
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[{ required: true, message: '请输入登录密码！' }]}
                    >
                      <Input.Password
                      prefix={<Icon name="lock-open"/>} 
                        placeholder="请输入密码"
                        iconRender={(visible) => (visible ? <EyeFilled /> : <EyeInvisibleFilled />)}
                      />
                    </Form.Item>
                    <div className='login-safe-code'>
                      <Form.Item
                        name="captcha"
                        rules={[{ required: true, message: '请输入验证码!' }]}
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                        
                      >
                        <Input
                          prefix={<Icon name="guard"/>} 
                          placeholder="请输入验证码"
                          // suffix={<ReloadOutlined className='ico-reload' onClick={getSafeCode}/>}
                        />
                        
                      </Form.Item>
                      <img src={safeCode.captcha_image ? `${baseURL}${safeCode.captcha_image}` : ''} alt='' onClick={getSafeCode} />
                      <Button onClick={getSafeCode} ghost type="primary" className='change-code'>换一张</Button>
                    </div>
                    {
                      // <Form.Item className='op-line'>
                      //   <Form.Item name="remember" valuePropName="checked" noStyle>
                      //     <Checkbox onClick={handleRemember}>记住密码</Checkbox>
                      //     <div className='forget-pass'>
                      //       <a href="/">忘记密码</a>
                      //       <Popover 
                      //         placement='right' 
                      //         title="提示" 
                      //         content="密码为6-8个大小写字母及符号构成的组合"
                      //         getPopupContainer={(parent) => parent}
                      //       >
                      //           <i>?</i>
                      //         </Popover>
                      //     </div>
                      //   </Form.Item>
                      // </Form.Item>
                    }
                    <Form.Item className='submit-item'>
                      <Button type="primary" htmlType="submit" className="login-form-button">
                        登录
                      </Button>
                    </Form.Item>
                  </Form> : null
              }
              { // 手机登录
                value === 2 ?
                  <Form
                  className="login-form"
                  onFinish={onMsgLogin}
                  form={form}
                >
                  <Form.Item
                    name="phone_number"
                    rules={[{ required: true, message: '请输入手机号!' }, { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: '请输入正确手机号!' }]}
                  >
                    <Input prefix={<Icon name="phone"/>} placeholder="请输入手机号" onChange={(v)=>{
                      setPhoneValue(v.target.value)
                    }} />
                  </Form.Item>
               
                  <Form.Item
                    // name="captcha"
                    // rules={[{ required: true, message: '请输入验证码!' }]}
                    className='phone-code-box'
                  >
                    <div className='phone-code-flex'>
                      <Form.Item
                      name="captcha"
                      rules={[{ required: true, message: '请输入短信验证码!' }]}
                      className='phone-code'
                    >
                        <Input
                          prefix={<Icon name="guard"/>}
                          type="password"
                          placeholder="请输入短信验证码"
                          autoComplete='off'
                          // suffix={<CheckCircleFilled className='ico-check-success'/>}
                        />
                      </Form.Item>
                      <span className={`get-code ${showCount?'get-code-disable':''}`} onClick={()=>{ 
                          if (showCount ) {
                            return;
                          }
                        if(!reg.test(phoneValue)) {
                          message.error('请输入正确的手机号码');
                          return;
                          
                        };
                        setIsModalOpen(true)
                      }}> 
                          {showCount
                    ? `${countTime}秒后重新获取`
                    : '获取验证码'}
                    </span>
                    </div>
                  </Form.Item>
                  {
                  //   <Form.Item className='op-line'>
                  //   <Form.Item name="remember" valuePropName="checked" noStyle>
                  //     <Checkbox>记住手机号</Checkbox>
                  //   </Form.Item>
                  // </Form.Item>
                  }
                 

                  <Form.Item className='submit-item' >
                    <Button type="primary" htmlType="submit" className="login-form-button">
                      登录
                    </Button>
                  </Form.Item>
                </Form>
                : null
              }
            </div>
            {
              // 手机绑定
              showMobileBind ?
              <MobileVerify 
                title="手机绑定"
                onOk={handleMobileBindOk}
                onCancel={handleMobileBindCancel}
                setShow={setShowMobileBind}
                expires={loginInfo?.expires}
              />
              : null
            }
            {
              // 手机验证
              showMobileVerify ?
              <MobileVerify 
                title="手机验证"
                phoneNumber={bindedPhoneNumber}
                onOk={handleMobileVerifyOk}
                onCancel={handleMobileVerifyCancel}
                setShow={setShowMobileVerify}
              />
              : null
            }
          </div>
        </div>
      </div>
      <div className='footer'>
        <p> &copy; 2023 陕西干部教育安全服务平台 陕ICP备10001194号-6</p>
      </div>
      <Modal title="请输入图形验证码" className='login-msg-modal' open={isModalOpen} onOk={sendMsgCode} onCancel={()=>{
        setIsModalOpen(false)
      }} cancelText="取消" okText="发送" >
        <div className='login-safe-code'>
          <div
            className='modal-input'
          >
            <Input
              prefix={<Icon name="phone"/>}
              placeholder="验证码"
              suffix={<ReloadOutlined className='ico-reload' onClick={getSafeCode}/>}
              value={imgCodeValue}
              onChange={(v)=>{
                setImgCodeValue(v.target.value)
              }}
            />
          </div>
          <img src={safeCode.captcha_image ? `${baseURL}${safeCode.captcha_image}` : ''} alt='' onClick={getSafeCode} />
        </div>
      </Modal>
    </div>
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => {
  return {
    getLoginDispatch({payload, callback}) {
      dispatch(action.getLogin({payload, callback}))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);